import { useContext, useEffect, useState, useRef } from 'react'
import { IObject, IResponse } from 'interfaces'
import useFetch from 'hooks/useFetch'
import { UserContext } from 'context/userContext'
import { GeneralContext } from 'context'
import { hasAccess, moneyToNumber } from 'helper/utils'
import {
  Loading,
  ShowDetails,
  DoclistHandle,
  UsersTable,
  Path,
} from 'components'
import useStorage from 'hooks/useStorage'
import * as Sessions from 'components/Modal/Items'
import ModalHeader from '../Components/ModalHeader'
import { Container } from './style'

export default function DetalhesContrato() {
  const { loading, setLoading, selectedId } = useContext(UserContext)
  const { gestor } = useContext(GeneralContext)
  const [data, setData] = useState<any>({})
  const [user] = useStorage('User')
  const api = useFetch(`/gestor/contract?id=${selectedId.current}`)
  const specialistList = gestor.get()
  const [_, setSpecialist] = useState<any>({})
  const formdata = useRef<FormData>(new FormData())

  const fetchData = async () => {
    try {
      setLoading(true)
      const response: IResponse = await api.fetch('get')
      if (response.fail) throw new Error(response.errors.message)
      const info = response.data.data
      switch (info.token.holderList.length) {
        case 0:
          info.capType = 'Aberta'
          break
        case 1:
          info.capType = 'Personalizada Individual'
          break
        default:
          info.capType = 'Personalizada em Grupo'
      }
      const { enterpriseId } = info.token
      info.documentList = []

      info.account = await api
        .fetch('get', null, `/gestor/account?id=${info.accountId}`)
        .then((r: IResponse) => r.data.data)

      info.enterprise = await api
        .fetch('get', null, `/gestor/enterprise?id=${enterpriseId}`)
        .then((r: IResponse) => r.data.data)

      info.attachment = { enterprise: [], contract: [] }
      // Enterprise
      ;['contract', 'enterprise'].forEach((s: string) => {
        ;['contract', 'document'].forEach((type: string) => {
          info[s][`${type}List`]?.forEach((c: IObject) => {
            info.attachment[s].push({
              name: c.type,
              file: c.file,
              type,
            })
          })
        })
      })

      setData(info)
      setLoading(false)
    } catch (err: any) {
      console.log('err', err)
      setLoading(false)
    }
  }

  useEffect(() => {
    setSpecialist(specialistList[0])
    fetchData()
  }, [])

  const invested: any = moneyToNumber(data?.contract?.invested)

  if (loading) return <Loading modal />
  return (
    <Container>
      <Path className="path">
        <span className="path">
          {'Gestão de clientes > Fluxo de contratos'}
        </span>
      </Path>
      <ModalHeader
        user={data?.account?.user}
        title={data?.token?.name}
        type={data?.capType}
        subtitle="Detalhes da captação"
        status={data?.contract?.status}
        tokenGestorId={data?.token?.gestorId}
        gestorId={data?.account?.account?.gestorId}
      />

      <Sessions.Info token={data.token} />
      <Sessions.Condition
        setData={setData}
        contractId={selectedId.current}
        token={data.token}
        contract={data.contract}
        enterprise={data.enterprise}
      />
      <Sessions.Contract token={data.token} contract={data?.contract} />
      <Sessions.Rental token={data.token} />
      <Sessions.Dates
        isInvesment={invested > 0}
        token={data.token}
        data={data}
      />
      {data?.bonus && <Sessions.Bonus data={data?.bonus} />}
      <Sessions.Payments
        token={{
          ...data.token,
          deadlineRemaining: data?.contract?.remainsMonths,
        }}
      />
      <Sessions.Simula
        id={data?.token?.id}
        name={data?.enterprise?.name}
        value={data?.token?.expected}
        isInsento={data?.token?.IRType === 'Isento'}
      />

      {data?.token?.holderList?.length > 1 && (
        <UsersTable
          captationID="id"
          data={data?.token?.holderList}
          disableDelete
        />
      )}
      <h4 className="detalhes-captacao-subtitle">Anexos do investimento</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          readonly={!hasAccess('detalhe-contract-add-documents')}
          documentList={data?.attachment?.contract}
          formdata={formdata.current}
          onChange={() => {
            api
              .fetch(
                'put',
                formdata.current,
                `/gestor/contract?id=${selectedId.current}`,
                { 'Content-type': 'multipart/form-data' }
              )
              .then(console.log)
          }}
        />
      </div>

      <h4 className="detalhes-captacao-subtitle">Anexos da captação</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle documentList={data?.attachment?.enterprise} readonly />
      </div>
    </Container>
  )
}
